<template>
  <div>
    <basic-info
      v-for="voter in voters"
      :key="voter.member_id"
      :name="voter.full_name"
      :profilePictureURL="voter.link"
    ></basic-info>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import basicInfo from '@/components/common/BasicInfo.vue';

export default {
  components: {
    basicInfo
  },
  computed: {
    ...mapState('poll', ['voters'])
  },
  created() {
    this.getVotingInfo();
  },
  methods: {
    ...mapActions('poll', ['getVotingInfo'])
  }
};
</script>

<style scoped></style>
